import { CallFromCallSideviewer, CargoActionFromCallSideviewer } from "view/calls/components/sideviewer/useCallSideviewer";
import { DocumentEntity } from "__generated__/enums";
import { intl } from "LocaleWrapper";
import { actionTypeToDocumentType } from "view/voyages/utils/VoyageUtils";
import VoyageDocuments from "view/voyages/components/documents/VoyageDocuments";

const CallSideviewerDocumentsBlock = (
	{
		call,
		selectedAction,
		cargoId,
		refetch,
		forceReadOnly,
	}: {
		call: CallFromCallSideviewer;
		selectedAction: CargoActionFromCallSideviewer | null;
		cargoId: number | null;
		refetch: () => void;
		forceReadOnly?: boolean;
	}) => {

	if (!selectedAction) {
		return null;
	}

	return <VoyageDocuments
		voyage={call.voyage}
		collapsable
		showActions={!forceReadOnly}
		entities={[ {
			id: cargoId ?? 0,
			cargoActionId: selectedAction.id,
			name: `${selectedAction.location?.description} - ${selectedAction.location?.displayCode || selectedAction.location?.code || ""} (${selectedAction.type && (intl.formatMessage({ id: selectedAction.type }))})`,
			type: selectedAction.type && actionTypeToDocumentType(selectedAction.type) || DocumentEntity.LoadingCargo,
			callId: selectedAction.call?.id } ]
		}
		refetch={refetch}
	/>;
};

export default CallSideviewerDocumentsBlock;
